var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDynamicText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "5.2 8.8 1.75 13.4 5.2 18 6.8 16.8 4.25 13.4 6.8 10 5.2 8.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.8 8.8 17.2 10 19.75 13.4 17.2 16.8 18.8 18 22.25 13.4 18.8 8.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14 5 18 5 18 7 20 7 20 3 4 3 4 7 6 7 6 5 10 5 10 20 8 20 8 22 16 22 16 20 14 20 14 5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicText);
export default __webpack_public_path__ + "static/media/dynamic_text.138ab7058eb9cbb86405cc2f72b3ba12.svg";
export { ForwardRef as ReactComponent };